<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-aqua primary"><i class="ion ion-ios-calendar"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Transactions Today</span>
            <span class="info-box-number">{{ daysTransactions }} </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->

      <!-- fix for small devices only -->
      <div class="clearfix visible-sm-block"></div>

      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-green secondary"><i class="ion ion-ios-calendar"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Transactions This Month</span>
            <span class="info-box-number">{{ monthsTransactions }} </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-yellow accent"><i class="ion ion-ios-calculator"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">All Transactions</span>
            <span class="info-box-number">{{ totalNumberOfTransactions }}</span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->

    </div>
    <!-- /.row -->
    <div class="row">
    <div class="col-xs-12">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title"></h3>
          <div class="box-body">
            <div class="col-sm-6 col-xs-12">
              <p class="text-center">
                <strong>Transactions This Week</strong>
              </p>
              <canvas id="trafficBar" ></canvas>
            </div>
            
            <hr class="visible-xs-block">
          </div>
          <div class="box-body">
            <div class="col-sm-12 col-xs-12">
              <p class="text-center">
                <strong>Transactions This Month</strong>
              </p>
              <canvas id="monthBar" ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import axios from 'axios'
import store from '../../store'
import config from '../../config'

export default {
  data () {
    return {
      generateRandomNumbers (numbers, max, min) {
        var a = []
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max)
        }
        return a
      },
      transactionsNumber: 0,
      daysTransactions: 0,
      monthsTransactions: 0,
      totalNumberOfTransactions: 0,
      loading: true,
      pagination: 0,
      thisWeeksTransactions: [],
      thisMonthTransactions: []
    }
  },
  computed: {
    coPilotNumbers () {
      return this.generateRandomNumbers(12, 1000000, 10000)
    },
    personalNumbers () {
      return this.generateRandomNumbers(12, 1000000, 10000)
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    },
    getNumberOfTransactionsTodayComputed () {
      return this.getNumberOfTransactions('/analytics/getNumberOfTransactionsToday')
    },
    getNumberOfTransactionsForTheMonthComputed () {
      return this.getNumberOfTransactions('/analytics/getMonthsNumberOfTransactions')
    },
    getTotalNumberOfTransactionsComputed () {
      return this.getNumberOfTransactions('/analytics/getTotalNumberOfTransactions')
    },
    getTotalNumberOfTransactionsThisWeekComputed () {
      return this.getThisWeekTransactionCount()
    },
    getTotalNumberOfTransactionsThisMonthComputed () {
      return this.getThisMonthTransactionCount()
    }
  },
  mounted () {
    this.daysTransactions = this.getNumberOfTransactionsTodayComputed
    this.monthsTransactions = this.getNumberOfTransactionsForTheMonthComputed
    this.totalNumberOfTransactions = this.getTotalNumberOfTransactionsComputed
    this.thisWeeksTransactions = this.getTotalNumberOfTransactionsThisWeekComputed
    this.thisMonthTransactions = this.getTotalNumberOfTransactionsThisMonthComputed
    console.log(this.thisWeeksTransactions)
  },
  watch: {
    thisWeeksTransactions: function () {
      this.updateCharts()
    },
    thisMonthTransactions: function () {
      this.updateCharts()
    }
  },
  methods: {
    updateCharts () {
      this.$nextTick(() => {
        var ctx = document.getElementById('trafficBar').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'],
            datasets: this.getDataSets(this.thisWeeksTransactions)
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }

        new Chart(ctx, config) // eslint-disable-line no-new

        var monthCtx = document.getElementById('monthBar').getContext('2d')
        var monthConfig = {
          type: 'line',
          data: {
            labels: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
            datasets: this.getDataSets(this.thisMonthTransactions)
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }

        new Chart(monthCtx, monthConfig) // eslint-disable-line no-new

        var pieChartCanvas = document.getElementById('storePie').getContext('2d')
        var pieConfig = {
          type: 'pie',
          data: {
            labels: ['Store 1', 'Store 2', 'Store 3'],
            datasets: [{
              data: [56.6, 37.7, 4.1],
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        }

        new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
      })
    },
    getDataSets (transactions) {
      var datasets = []
      console.log(transactions.length)
      for (var i = 0; i < transactions.length; i++) {
        var datasetObj = {}
        datasetObj.label = transactions[i].storeName
        datasetObj.fill = false
        datasetObj.borderColor = '#284184'
        datasetObj.pointBackgroundColor = '#284184'
        datasetObj.backgroundColor = 'rgba(0, 0, 0, 0)'
        datasetObj.data = transactions[i].counts
        var sum = this.sumCounts(transactions[i].counts)
        if (sum !== 0) {
          console.log(transactions[i].storeName + ' ' + sum)
          datasets.push(datasetObj)
        }
      }
      return datasets
    },
    sumCounts(arr) {
      let sum = 0
      for (let i = 0; i < arr.length; i++) {
        sum = sum + arr[i]
      }
      return sum
    },
    getNumberOfTransactions (uri) {
      var url = config.serverURI + uri
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            if (uri === '/analytics/getNumberOfTransactionsToday') {
              this.daysTransactions = response.data.message
            } else if (uri === '/analytics/getMonthsNumberOfTransactions') {
              this.monthsTransactions = response.data.message
            } else if (uri === '/analytics/getTotalNumberOfTransactions') {
              this.totalNumberOfTransactions = response.data.message
            }
            this.transactionsNumber = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.transactionsNumber
    },
    getThisWeekTransactionCount () {
      var url = config.serverURI + '/analytics/getThisWeekTransactions'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.thisWeeksTransactions = response.data
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.thisWeeksTransactions
    },
    getThisMonthTransactionCount () {
      var url = config.serverURI + '/analytics/getThisMonthTransactions'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.thisMonthTransactions = response.data
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.thisMonthTransactions
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?ef1f21ae